import { motion } from "framer-motion";
import { Facebook, Instagram, Home, Tag, Briefcase } from "lucide-react";
import logo from "@/assets/logo.webp";
import { SEO } from "@/components/SEO";

const links = [
  { name: "Homepage", href: "/", icon: Home, external: false },
  {
    name: "Angebote",
    href: "https://www.rewe.de/marktseite/floersheim-weilbach/240367/rewe-markt-industriestrasse-40/?&market-flyer=active",
    icon: Tag,
    external: true,
  },
  { name: "Jetzt bewerben", href: "/kontakt", icon: Briefcase, external: false },
  {
    name: "Facebook",
    href: "https://www.facebook.com/people/Rewe-V-Gahndi/100063530618457/",
    icon: Facebook,
    external: true,
  },
  {
    name: "Instagram",
    href: "https://www.instagram.com/rewe_v._gahndi/",
    icon: Instagram,
    external: true,
  },
];

export default function AllInLink() {
  return (
    <main className="min-h-screen bg-background flex flex-col items-center justify-center px-4 py-12">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-md flex flex-col items-center"
      >
        <img
          src={logo}
          alt="REWE V. Gahndi Logo"
          className="h-32 w-auto mb-8"
        />
        <h1 className="sr-only">REWE V. Gahndi – All in Link</h1>

        <div className="gold-line w-full mb-8" />

        <nav aria-label="All in Link Navigation" className="w-full">
          <ul className="space-y-4">
            {links.map((link, index) => {
              const Icon = link.icon;
              const commonClasses =
                "flex items-center justify-center gap-3 w-full px-6 py-4 rounded-xl border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300 text-base font-semibold uppercase tracking-wider";
              return (
                <motion.li
                  key={link.name}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, delay: 0.1 + index * 0.08 }}
                >
                  {link.external ? (
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={commonClasses}
                    >
                      <Icon className="w-5 h-5 flex-shrink-0" />
                      <span>{link.name}</span>
                    </a>
                  ) : (
                    <a href={link.href} className={commonClasses}>
                      <Icon className="w-5 h-5 flex-shrink-0" />
                      <span>{link.name}</span>
                    </a>
                  )}
                </motion.li>
              );
            })}
          </ul>
        </nav>

        <div className="gold-line w-full mt-10 mb-6" />
        <p className="text-sm text-muted-foreground text-center">
          REWE V. Gahndi oHG · Industriestraße 40 · 65439 Flörsheim-Weilbach
        </p>
      </motion.div>
    </main>
  );
}